// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1b9aa4f2","456":"f9232b77"}[chunkId] + ".chunk.js";
};